export default __webpack_public_path__ + "static/media/rapity_img.7437dc8f.png";